export default __webpack_public_path__ + "static/media/glr-5.96ce0035.webp";